var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whatsapp-bubble"},[(_vm.header)?[(_vm.header.type === 'TEXT')?_c('div',{staticClass:"whatsapp-text-header"},[_vm._v(_vm._s(_vm.header.body))]):_vm._e(),(_vm.header.type === 'IMAGE')?_c('div',{staticClass:"whatsapp-text-header"},[_c('img',{attrs:{"src":_vm.header.example_parameter}})]):_vm._e()]:_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }